import { Flex, IconButton, Tooltip } from '@chakra-ui/react';
import useTranslate from '~/common/utils/translate';
import React, { useEffect, useState } from 'react';
import { AddIcon } from '@chakra-ui/icons';
import { Input } from './Input';

type SearchAndAddProps = {
  onInputChange: (input: string) => void;
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  inputPlaceholder: string;
  tooltipLabel: string;
};

export const SearchAndAddBar: React.FC<SearchAndAddProps> = ({
  onInputChange,
  onClick,
  inputPlaceholder: placeHolderInput,
  tooltipLabel: labelTooltip,
}) => {
  const translate = useTranslate();
  const [input, setInput] = useState('');
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      onInputChange(input);
    }, 500);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [input]);
  return (
    <Flex align="center" width="100%">
      <Tooltip
        label={translate(labelTooltip)}
        aria-label={translate(labelTooltip)}
      >
        <IconButton
          icon={<AddIcon />}
          onClick={onClick}
          aria-label={translate(labelTooltip)}
          isRound
          mr={2}
        />
      </Tooltip>
      <Input
        value={input}
        placeholder={placeHolderInput}
        onChange={(e) => setInput(e.target.value)}
      />
    </Flex>
  );
};
